import React from "react";
import { Chart } from "chart.js";
import { H4, Card } from "@blueprintjs/core";
import i18n from "../../i18n";
import { generic_colors } from "./Colors";
import { mefMontantStr } from "../../utils/mef";

const Xlinear = {
  /* type: 'linear' */
};

const Xtime = {
  type: "time",
  time: {
    //unit: 'hour'
  },
};

const BarChart = class extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    let datasets;

    datasets = [
      {
        label: this.props.title,
        data: this.props.data,
        fill: "none",
        backgroundColor: "#2965cc",
        pointRadius: 5,
        borderWidth: 0,
        lineTension: 0.3,
      },
    ];

    this.myChart = new Chart(this.canvasRef.current, {
      type: "bar",
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          zoom: {
            pan: {
              enabled: true,
              mode: "x",
            },
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true,
              },
              mode: "x",
            },
            limits: {
              x: { min: "original", max: "original", minRange: 20 },
            },
          },
        },
        interaction: {
          intersect: false,
          mode: "index",
        },
      },
      data: {
        labels: this.props.labels,
        datasets: datasets,
      },
    });
  }

  componentDidUpdate() {
    if (this.props.labels !== undefined && this.props.data !== undefined) {
      this.myChart.data.labels = this.props.labels;
      this.myChart.data.datasets[0].data = this.props.data;
      this.myChart.update();
    } else {
      this.myChart.clear();
    }
  }

  render() {
    return (
      <Card className="medium-chart-container">
        <H4 className="chart-title noselect">{this.props.title}</H4>
        <canvas ref={this.canvasRef} />
      </Card>
    );
  }
};

export default BarChart;

export const MultiBarChart = class extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
  }

  componentDidUpdate() {
    if (this.props.labels !== undefined && this.props.datasets !== undefined) {
      this.myChart.data.labels = this.props.labels;

      let i = 0;
      this.myChart.data.datasets = [];
      for (const dataset of this.props.datasets || []) {
        if (dataset)
          this.myChart.data.datasets[i] = {
            label: i18n.t(dataset.title),
            data: dataset.data,
            fill: true,
            backgroundColor: generic_colors[i],
            borderColor: generic_colors[i++],
            pointRadius: 0,
          };
      }
      this.myChart.update();
    } else {
      this.myChart.clear();
    }
  }

  componentDidMount() {
    const datasets = [];
    let i = 0;
    for (const dataset of this.props.datasets || []) {
      if (dataset)
        datasets.push({
          label: i18n.t(dataset.title),
          data: dataset.data,
          fill: true,
          backgroundColor: generic_colors[i],
          borderColor: generic_colors[i++],
          pointRadius: 0,
        });
    }

    let formatter;
    if (this.props.unitType === "amount")
      formatter = (item) => `${mefMontantStr(item.raw * 100)}`;

    this.myChart = new Chart(this.canvasRef.current, {
      type: "bar",
      options: {
        animation: false,
        normalized: true,
        scales: {
          yAxes: {
            stacked: true,
            ticks: {
              min: 0,
            },
          },
          xAxes: {
            ...(this.props.format !== undefined && this.props.format === "date"
              ? Xtime
              : Xlinear),
            stacked: true,
          },
        },
        plugins: {
          zoom: {
            pan: {
              enabled: true,
              mode: "x",
            },
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true,
              },
              mode: "x",
            },
            limits: {
              x: { min: "original", max: "original", minRange: 10 },
            },
          },
          tooltip: {
            callbacks: {
              label: formatter,
            },
          },
        },
        interaction: {
          intersect: false,
          mode: "index",
        },
      },
      data: {
        labels: this.props.labels,
        datasets: datasets,
      },
    });
  }

  render() {
    return (
      <Card
        className={
          this.props.large !== undefined && this.props.large
            ? "big-chart-container"
            : "medium-chart-container"
        }
      >
        <H4 className="chart-title noselect">{this.props.title}</H4>
        <canvas ref={this.canvasRef} />
        {/* data = {this.props.datasets} */}
      </Card>
    );
  }
};
